import slideToggle from './animation/slideToggle';
import forEachSelector from './elements/forEachSelector';
import addStartupScript from './events/addStartupScript';

// Gets the collapsible sibling of an element
const collapsibleElement = button => {
  if(button.dataset.collapsibleTarget) {
    return document.querySelector(button.dataset.collapsibleTarget);
  } else {
    return getSiblings(button).filter(el => el.classList.contains('collapsible-section'))[0];
  }
};

// Gets all siblings of an element
const getSiblings = n =>
  Array.from(n.parentElement.children).filter(c => c !== n);

function setupButton(button) {
  const collapsible = collapsibleElement(button);
  const content = button.querySelector('.collapsible-trigger__content') || button;
  const initialButtonText = content.innerHTML;
  if(collapsible) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      if(button.dataset.collapsibleHide && !button.classList.contains('button')) {
        slideToggle(button);
      }

      if(button.classList.contains('button')){
        button.style.display = 'none';
      }

      slideToggle(collapsible);

      // Updates clickable text when expanded/collapsed
      if (button.dataset.expandedText) {
        content.innerHTML = button.dataset.expandedText;
      }

      if(collapsible.offsetHeight > 0) {
        content.innerHTML = initialButtonText;
      }
    });
  }
}

export function setup() {
  forEachSelector('.collapsible-trigger', setupButton);
}

addStartupScript(setup);
